// extracted by mini-css-extract-plugin
export default {"questions":"style_questions__aZ+xg","asterisk":"style_asterisk__r87cm"};